/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View } from 'react-native';
import CheckBoxView from '@airasia-phoenix/react-native/components/CheckBoxView';
import { LabelView } from '@airasia-phoenix/react-native/components';
import { CheckboxProps } from './types';
import Constants from '../../widgets/FlightSearchWidget/constants';
import { StyleSheet } from 'react-native-unistyles';

const CheckboxView = (props: CheckboxProps) => {
  const { isChecked, label, labelHighlighter, onPress, disabled } = props;
  return (
    <View style={styles.container}>
      <CheckBoxView
        isSelected={isChecked}
        label={label}
        onPress={(state) => {
          if (disabled) return;
          onPress(state.isSelected);
        }}
        isDisabled={disabled}
        labelStyles={styles.label}
      />
      {!!labelHighlighter && (
        <View style={styles.labelContainer}>
          <LabelView
            type={Constants.FLIGHT_HOTEL_PROMOTION_LABEL_TYPE}
            text={labelHighlighter}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  labelContainer: { marginLeft: 12, justifyContent: 'center' },
  label: {
    fontSize: 14,
  },
});

export default CheckboxView;
